import React from "react";
import { useIntl } from "react-intl";
import { transfersShipmentCreateLabels } from "transfers/create/transfersShipmentCreate.labels";
import { useTransferSelectDestinationFcStep } from "./hooks/useTransferSelectDestinationFcStep";
import { ManagedStep } from "common/components/StepContainer";
import { RadioTileGroup } from "common/components/ui";
import { Direction } from "common/components/ui/shared";
import { LoadingSpinner } from "common/components/LoadingSpinner";

export const TransferSelectDestinationFcStep = () => {
  const { formatMessage } = useIntl();
  const {
    warehouseOptions,
    selectedWarehouseId,
    isWarehouseDetailsLoading,
    isNextDisabled,
    isLoading,
    handleDestinationChange,
  } = useTransferSelectDestinationFcStep();
  return (
    <ManagedStep
      data-testid="transfer-select-destination-fc-step"
      title={formatMessage(transfersShipmentCreateLabels.steps.destinationWarehouse.title)}
      isNextDisabled={isNextDisabled}
      isLoading={isLoading}
    >
      {isWarehouseDetailsLoading ? (
        <LoadingSpinner center size="large" />
      ) : (
        <RadioTileGroup
          block
          direction={Direction.VERTICAL}
          currentValue={selectedWarehouseId}
          options={warehouseOptions}
          onChange={handleDestinationChange}
        />
      )}
    </ManagedStep>
  );
};
